
            const data = {"name":"icon-arrow-small","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M10.181 30.934a1.92 1.92 0 11-2.715-2.715l13.576-13.576a1.92 1.92 0 112.715 2.715L10.181 30.934z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M7.466 3.781a1.92 1.92 0 112.715-2.715l13.576 13.576a1.92 1.92 0 11-2.715 2.715L7.466 3.781z\"/>"}}
        
                module.exports = data
                